export default "__VITE_ASSET__ChdgVint__"